<template>
  <div>
    <b-modal
      ref="modal-route"
      centered
      no-close-on-backdrop
      header-bg-variant="light"
      footer-bg-variant="light"
      size="lg"
      button-size="sm"
    >
      <template #modal-header="">
        <h5>FILE OF ROUTES</h5>
        <b-button @click="addroute()" class="btnAdd" size="sm" variant="dark">
          <!-- <strong>NEW</strong> -->
          New
        </b-button>
      </template>
      <b-tabs
        v-model="activeTab"
        small
        pills
        active-nav-item-class="font-weight-bold text-white"
      >
        <b-tab
          v-for="(division, index) in divisiones"
          :active="index === activeTab"
          :title="division.nombre"
          :key="division.id_division"
          @click="id_division = division.id_division"
        >
        </b-tab>
      </b-tabs>
      <b-table
        hover
        striped
        select-mode="single"
        small
        sticky-header
        :items="itemsFiltrados"
        :fields="fields"
        :busy="isBusy"
        head-variant="dark"
        class="mt-3"
        bordered
        style="max-height: 500px"
        ref="selectableTable"
        selectable
      >
        <template #cell(qcolor)="row">
          <div
            v-bind:style="{
              width: '100%',
              height: '100%',
              background: row.item.color,
              color: colorText,
            }"
          >
            .
          </div>
        </template>

        <template #cell(delete)="row">
          <b-button
            variant="outline-danger"
            @click="promptDelete(row.item, row.index)"
          >
            <b-icon icon="trash"></b-icon>
          </b-button>
        </template>

        <template #cell(edit)="row">
          <b-button @click="editroute(row.item)" variant="outline-success">
            <b-icon icon="pencil"></b-icon>
          </b-button>
        </template>

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>

      <template #modal-footer="{}">
        <div class="w-100">
          <p class="float-left">
            <strong> Count: {{ count }}</strong>
          </p>
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button
            class="float-right"
            size="sm"
            variant="secondary"
            @click="goHome()"
          >
            go Back
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      v-model="modalEditShow"
      no-close-on-backdrop
      header-bg-variant="light"
      footer-bg-variant="light"
      size="lg"
      button-size="sm"
      centered
    >
      <template #modal-header="">
        <h5>Edit Route</h5>
      </template>
      <b-card bg-variant="light">
        <b-form-group label-cols-lg="1" class="mb-0">
          <b-form-group
            label="Route"
            label-for="route"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-select
              v-model="actualroute.color"
              :options="optionColors"
              size="sm"
              class="mt-3"
            ></b-form-select>
          </b-form-group>

          <b-form-group
            label="Color"
            label-for="color"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="color"
              v-bind:style="{
                width: '100%',
                height: '100%',
                background: actualroute.color,
                color: colorText,
              }"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="Zona"
            label-for="zona"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="address"
              v-model="actualroute.zonas"
              :formatter="mayusculas"
            ></b-form-input>
          </b-form-group>
        </b-form-group>
      </b-card>
      <template #modal-footer="{}">
        <div class="w-100">
          <b-button
            class="float-left"
            size="sm"
            variant="secondary"
            @click="modalEditShow = !modalEditShow"
          >
            go Back
          </b-button>
          <b-button
            class="float-right"
            size="sm"
            variant="success"
            @click="showMsgSave()"
          >
            Save
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      v-model="modalAddShow"
      no-close-on-backdrop
      header-bg-variant="light"
      footer-bg-variant="light"
      size="lg"
      button-size="sm"
      centered
    >
      <template #modal-header="">
        <h5>Add New Route</h5>
      </template>
      <b-card bg-variant="light">
        <b-form-group label-cols-lg="1" class="mb-0">
          <b-form-group
            label="Route:"
            label-for="route"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-select
              v-model="newroute.color"
              :options="colorsOptNewRoute"
              size="sm"
              class="mt-3"
            >
            </b-form-select>
          </b-form-group>

          <b-form-group
            label="Color"
            label-for="color"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="color"
              v-bind:style="{
                width: '100%',
                height: '100%',
                background: newroute.color,
                color: colorText,
              }"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Zona:"
            label-for="zona"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="zona"
              :formatter="mayusculas"
              v-model="newroute.zonas"
            ></b-form-input>
          </b-form-group>
        </b-form-group>
      </b-card>
      <template #modal-footer="{}">
        <div class="w-100">
          <b-button
            class="float-left"
            size="sm"
            variant="secondary"
            @click="modalAddShow = !modalAddShow"
          >
            go Back
          </b-button>
          <b-button
            v-if="newroute.color != null"
            class="float-right"
            size="sm"
            variant="success"
            @click="insertRoute()"
          >
            Save
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "routes",
  data: function () {
    return {
      url: "https://www.imandrades.com/apiIMA/rutas.php",
      urlD: "https://www.imandrades.com/apiIMA/divisiones.php",
      isBusy: false,
      fields: [
        { key: "color", label: "Route", class: "text-left" },
        { key: "qcolor", label: "Color", class: "text-center" },
        { key: "zonas", label: "Zone", class: "text-left" },
        { key: "delete", class: "text-center" },
        { key: "edit", class: "text-center" },
      ],
      modalEditShow: false,
      modalAddShow: false,
      items: [],
      routes: [],
      actualroute: {},
      newroute: {},
      boxOk: "",
      count: 0,
      colores: [],
      divisiones: [],
      coloresDisponibles: [],
      colorsOptNewRoute: [],
      optionColors: [],
      colorSelected: "",
      selected: [],
      confirmDelete: "",
      id_division: 0,
      actualDivision: "",
      activeTab: 99,
      actualRoute: "",
      actualCC: "",
      categorySelected: "0",
      colorText: "darkgray",
    };
  },
  mounted() {
    this.$refs["modal-route"].show();
    this.id_division = localStorage.getItem("id_division");
    this.actualDivision = localStorage.getItem("division");
    this.leerDivisiones();
    this.leerRutas();
    this.leerColores();
  },
  computed: {
    // un getter computado

    itemsFiltrados: function () {
      return this.items.filter((it) => {
        return it.id_division == this.id_division;
      });
    },
  },

  methods: {
    mayusculas(value) {
      return value.toUpperCase();
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ["bg-warning", "text-light"];
      } else {
        return ["bg-light", "text-info"];
      }
    },
    leerRutas: async function () {
      try {
        let respuesta = await axios.get(this.url, {
          params: {
            action: "getRutas",
            id: this.id_division,
          },
        });
        this.routes = respuesta.data.rutas;
        this.items = this.routes;
        /*          this.items = this.routes.filter(function (rut) {
          return (rut.id_division = this.id_division);
        }); */
        this.count = this.items.length;
      } catch (error) {
        console.log("Error Leyendo routes");
      }
    },
    leerColores: async function () {
      try {
        let respuesta = await axios.get(this.url, {
          params: {
            action: "getColores",
          },
        });
        this.colores = respuesta.data.colores;
        this.colores.forEach((color) => {
          this.optionColors.push({
            value: color,
            text: color,
          });
        });
      } catch (error) {
        console.log("Error Reading Colors");
      }
    },
    leerDivisiones: async function () {
      try {
        let respuesta = await axios.get(this.urlD + "?action=getDivisiones");
        this.divisiones = respuesta.data.divisiones;
        this.activeTab = this.divisiones
          .map(function (d) {
            return d.id_division;
          })
          .indexOf(this.id_division);
      } catch (error) {
        console.log("Error Reading Divisions");
      }
    },
    deleteRoute: async function (item, index) {
      try {
        let respuesta = await axios.get(this.url, {
          params: {
            action: "deleteRoute",
            id_ruta: item.id_ruta,
          },
        });
        if (respuesta.data.deleted) {
          this.$bvModal
            .msgBoxOk("Action completed")
            .then((value) => {
              this.boxOk = value;
              if (this.boxOk) {
                this.items.splice(index, 1);
                this.count = this.items.length;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } catch (error) {
        console.log("Error Reading Colors");
      }
    },

    insertRoute: async function () {
      let param = {
        id_division: this.id_division,
        color: this.newroute.color,
        zonas: this.newroute.zonas,
      };
      let paramSave = this.toFormData(param);
      try {
        let respuesta = await axios.post(
          this.url + "?action=insertRoute",
          paramSave
        );
        if (respuesta.data.saved) {
          this.$bvModal
            .msgBoxOk("Action completed")
            .then((value) => {
              this.boxOk = value;
              if (this.boxOk) {
                this.items.push(param);
                this.modalAddShow = false;
                this.updateColoresDisponibles();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } catch (error) {
        console.log("Error Reading Colors");
      }
    },

    goHome() {
      this.$refs["modal-route"].hide();
      this.$router.push("menuDesktop");
    },
    /* onRowSelected() {
      this.selected = items;
      console.log(this.selected);
    }, */

    editroute(item) {
      this.actualroute = item;
      this.modalEditShow = true;
    },
    updateColoresDisponibles() {
      this.colorsOptNewRoute = [];
      this.coloresDisponibles = this.colores
        .filter(
          (color) =>
            !this.itemsFiltrados
              .map(function (r) {
                return r.color;
              })
              .includes(color)
        )
        .forEach((color) => {
          this.colorsOptNewRoute.push({
            value: color,
            text: color,
          });
        });
    },
    addroute() {
      /*  let colorRoute = [];
      this.routes.forEach((c) => {
        colorRoute.push(c.color);
      });
      this.coloresDisponibles = this.colores.filter(
        (color) => !colorRoute.includes(color)
      ); */
      this.updateColoresDisponibles();
      this.newroute = {};
      this.modalAddShow = true;
    },

    promptDelete(item, index) {
      this.confirmDelete = "";
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to delete route '" + item.color + "'",
          {
            title: "Delete route",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          this.confirmDelete = value;
          if (this.confirmDelete) {
            this.deleteRoute(item, index);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showMsgSave() {
      this.boxTwo = "";
      this.modalEditShow = false;
      this.modalAddShow = false;
      this.$bvModal.msgBoxOk("Data was submitted successfully", {
        title: "Confirmation",
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true,
      });
    },
    toFormData(obj) {
      let fd = new FormData();
      for (var i in obj) {
        fd.append(i, obj[i]);
      }
      return fd;
    },
  },
};
</script>


<style scoped>
.btnAdd {
  display: block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.btnAdd:hover {
  transform: scale(1.2);
}
</style>

